// extracted by mini-css-extract-plugin
export default {"container":"PromoPage_container__AatUN","screeningHeader":"PromoPage_screeningHeader__rDhaP"};